import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import SuccessErrorMsg from "../../../utilities/SuccessErrorMsg";
import { passwordValidation } from '../../../utilities/validations/inputsValidations';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';


export default function ActiveUserPassword() {
  const { register, handleSubmit, formState: { errors }, watch } = useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { token } = useParams();
  const { t, i18n } = useTranslation();

  async function onSubmit(data) {
    // setLoading(true);
    // console.log(data);
    try {
      await axios.patch(
        `${process.env.REACT_APP_MASAR_API_URL}/auth/reset-password/${token}`, data,
        {
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      )
      // setSuccess(true)

      i18n.language === 'ar' ?
        toast.success("تم تسجيلكم بنجاح..شكرا لك .. جاري الانتقال لصفحة التسجيل") : toast.success("You have been registered successfully.. Thank you.. Redirecting to the login page");

      setTimeout(() => {
        navigate('/logIn');
      }, 3000);
    } catch (error) {
      console.error("An error occurred during login", error);
      toast.warn(t("errorTryAgain"));
      setTimeout(() => {
        navigate('/resetPassword');
      }, 3000);

    } finally {
      setLoading(false);
    }
  };


  return (
    <div className='dashboard bg-light-beige col-12 position-relative'>
      <div className='bg-white h-50'></div>
      {loading ?
        <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>
        :
        <div className='dashboard-form container col-10 col-md-6 px-4 py-5 text-start h-50 bg-dark-orange rounded-4 border border-2 shadow border-white position-absolute top-50 start-50 translate-middle'>
          <h4 className='text-white'>{t("Active Account")}</h4>
          <form className='d-flex flex-column mx-auto my-5 gap-3 text-start' onSubmit={handleSubmit(onSubmit)}>
            <input className='form-control' type="Password" placeholder={t("password")}
              {...register("password", { required: true, pattern: passwordValidation })} />
            {errors.password && <p className='errors-msg'>{t("errorPassword")}</p>}

            <input className='form-control' type="password" placeholder={t("Confirm Password")}
              {...register("confirmedPassword", {
                required: true, validate: (val) => {
                  if (watch('password') !== val) { return "Your passwords do no match"; }
                },
              })} />
            {errors.password !== errors.confirmedPassword && <p className='errors-msg'>{t("Password Not Match")}</p>}


            <input className='btn btn-light-beige text-white' type="submit" value={t("Submit")} />
          </form>
          <SuccessErrorMsg
            ToastContainer={ToastContainer}
          />

        </div>
      }

      <div className='d-none d-sm-block col-6 bg-light-beige'>
      </div>
    </div>

  )
}
